/* @flow */
import produce from 'immer';
import { message } from 'antd';
import { actionTypes } from './actions';
import { defineServerErrors } from '@/utils/redux';

const {
  FETCH_RESOURCES,
  FETCH_SUCCESS,
  FETCH_FAILED,

  UPLOAD_RESOURCE,
  UPLOAD_RESOURCE_SUCCESS,
  UPLOAD_RESOURCE_FAILED,

  DELETE_RESOURCE,
  DELETE_RESOURCE_SUCCESS,
  DELETE_RESOURCE_FAILED,

  BEFORE_UPLOAD,
  ON_REMOVE_FILE,
  SET_FILE_NAME,
  TABLE_CHANGE,
} = actionTypes;

type State = {
  isFetching: boolean,
  tableOptions: TableT,
  data: ResourceT[],
  resource: ?ResourceT,
  errors: ?Array<string>,
  fileName: string,
  fileList: any[],
};

const initialState = {
  isFetching: false,
  tableOptions: {
    page: 1,
    limit: 10,
    count: 0,
  },
  resource: null,
  data: [],
  errors: null,
  fileName: '',
  fileList: [],
};

export default (state: State = initialState, action: ActionT = {}): State =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case FETCH_RESOURCES:
        draft.isFetching = true;
        return;
      case FETCH_SUCCESS: {
        const { results, page, limit, count } = action.payload;
        draft.isFetching = false;
        draft.data = results;
        draft.errors = initialState.errors;
        draft.tableOptions = {
          page,
          limit,
          count,
        };
        return;
      }
      case FETCH_FAILED:
        draft.isFetching = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case UPLOAD_RESOURCE:
        draft.isFetching = true;
        return;
      case UPLOAD_RESOURCE_SUCCESS:
        draft.isFetching = false;
        draft.resource = action.payload;
        draft.errors = initialState.errors;
        return;
      case UPLOAD_RESOURCE_FAILED:
        draft.isFetching = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case DELETE_RESOURCE:
        draft.isFetching = true;
        return;
      case DELETE_RESOURCE_SUCCESS:
        draft.isFetching = false;
        draft.errors = initialState.errors;
        message.success('Resource deleted successfully');
        return;
      case DELETE_RESOURCE_FAILED:
        draft.isFetching = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case BEFORE_UPLOAD:
        draft.fileList = [action.payload];
        return;
      case ON_REMOVE_FILE: {
        draft.fileList = [];
        return;
      }
      case SET_FILE_NAME:
        draft.fileName = action.payload;
        return;
      case TABLE_CHANGE:
        draft.tableOptions = action.payload;
        return;
    }
  });
